export default __webpack_public_path__ + "static/media/annotation-animation.7fcff9e2.svg";